import { de } from '../../../lib/i18n/de';
import { MoneyInput } from '../../../components/finance/MoneyInput';
import { BwaUpload } from '../../../components/finance/BwaUpload';
import { FieldHelp } from '../../../components/forms/FieldHelp';
import type { ResourcesDraft } from '../../../lib/store/wizard';

interface BwaInputStepProps {
  resources: ResourcesDraft;
  onRevenueChange: (cents: number | null) => void;
  onCostsChange: (cents: number | null) => void;
}

/** Sub-Step 4.1: BWA-Eckdaten (Umsatz, Kosten, abgeleiteter Gewinn). */
export function BwaInputStep({ resources, onRevenueChange, onCostsChange }: BwaInputStepProps) {
  const t = de.steps.resources.subSteps.bwa;
  const profit =
    resources.revenueCents !== null && resources.costsCents !== null
      ? resources.revenueCents - resources.costsCents
      : null;

  return (
    <div className="space-y-8">
      <p className="max-w-prose font-serif text-base italic text-stone-500 md:text-lg">{t.intro}</p>

      <BwaUpload
        onParsed={({ revenueCents, costsCents }) => {
          onRevenueChange(revenueCents);
          onCostsChange(costsCents);
        }}
      />

      <div>
        <MoneyInput
          valueCents={resources.revenueCents}
          onChange={onRevenueChange}
          label={t.revenueLabel}
          hint={t.revenueHint}
          placeholder="z.B. 4.500,00"
        />
        <div className="mt-2">
          <FieldHelp pathKey="resources.bwa.revenue" />
        </div>
      </div>

      <div>
        <MoneyInput
          valueCents={resources.costsCents}
          onChange={onCostsChange}
          label={t.costsLabel}
          hint={t.costsHint}
          placeholder="z.B. 1.800,00"
        />
        <div className="mt-2">
          <FieldHelp pathKey="resources.bwa.costs" />
        </div>
      </div>

      <div className="border-t border-stone-200 pt-6">
        <MoneyInput
          valueCents={profit}
          onChange={() => {
            // read-only — onChange wird nicht aufgerufen
          }}
          label={t.profitLabel}
          hint={t.profitHint}
          readOnly
          allowNegative
        />
        <div className="mt-2">
          <FieldHelp pathKey="resources.bwa.profit" />
        </div>
      </div>
    </div>
  );
}
